export const AUTH_COMPONENT_CONTAINER = '.js-auth-component-container';
export const AUTH_COMPONENT = '.js-auth-component';
